export default {
  'Animate old photos': '오래된 사진을 애니메이션화합니다.',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'AI 기술로 사진 속 얼굴을 애니메이션화해 생생한 영상을 만들어 보세요.',
  'Upload a photo': '사진 업로드',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    '참고: 선택한 사진의 얼굴이 렌즈를 향하고 있는지 확인하십시오. 그렇지 않으면 성공적으로 처리할 수 없습니다.',
  'Uploaded successfully!': '성공적으로 업로드되었습니다!',
  'Please select a template below': '아래 템플릿을 선택하십시오.',
  'Choose a GIF': 'GIF를 선택하십시오.',
  'Use this template': '이 템플릿을 사용합니다.',
  'Verify successfully! You will':
    '성공적으로 확인되었습니다! 곧 {{email}}으로 동영상을 받을 수 있습니다.',
  'You will': '곧 {{email}}으로 동영상을 받을 수 있습니다.',
  'What you should expect to happen next': '다음에 어떤 일이 일어날까요?',
  'We will process your photo into a dynamic video.':
    '사진을 동적 비디오로 처리하겠습니다.',
  'After processing, we will send the video to your email.':
    '처리 후 동영상을 이메일로 보내드립니다.',
  'You can check the video in your email.':
    '동영상은 이메일에서 확인할 수 있습니다.',
  'Your video will be delivered via email':
    '귀하의 동영상은 이메일을 통해 전달됩니다.',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    '동적 비디오를 합성하는 데 20-30분이 걸립니다. 기다려 주십시오. 개인 정보를 보호하기 위해 업로드된 사진은 처리가 끝난 후 자동으로 삭제됩니다.',
  'Your Email': '이메일',
  'Last Name': '이름',
  'First Name': '성씨',
  'Go back': '돌아가기',
  'Invalid email address': '이메일 주소가 잘못되었습니다.',
  'Enter verification code': '인증번호를 입력하세요',
  'Enter the verification code that we sent to':
    '输入我们发送给{{email}}的验证码。',
  Resend: '다시 보냅니다.',
  'Verification code': '인증번호',
  'Resend after': '{{num}}s이후에 다시 보내겠습니다',
  'The verification code is invalid. You can request a new one.':
    '인증번호가 잘못되었습니다. 새 것을 요청할 수 있습니다.',
  'Synthesize Video': '비디오 합성하기 ',
  Next: '다음',
  'Too many attempts, please try again later.':
    '많이 시도를 했습니다.잠시 후에 다시 해보십시오.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
